import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input, Alert } from "antd";
import { _uuid } from "../../utils/dataUtil";
import {
  req_add_pim_bunchLog_out,
  req_add_pim_bunchLog_overtime_out,
} from "../../api";
class OverTimeSelfModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
    ip: PropTypes.string.isRequired,
    onSuccess: PropTypes.func,
  };
  state = {
    lock: false,
    reason: "",
    SetOverStartTime: "1730",
    row: {
      Uid: "",
      StaffCode: "",
      BunchDate: "",
      BunchTime: new Date(),
      BunchMessage: "SUCCESS",
      BunchStatus: "REALTIME",
      BunchType: "WEB",
      RecordIP: "0.0.0.0",
      NetworkStatus: "ALL",
      BackFillStatus: "NONE",
      RecordDescription: "",
      SetOverStartTime: "1730",
    },
  };

  componentDidMount() {
    this.initStartOvertime();
  }

  api_add_item_bunchout = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_out(item, token);
    return result.status;
  };

  api_add_item_bunchout_overtime = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_bunchLog_overtime_out(item, token);
    return result.status;
  };

  convertDateTime = (string_date, string_time) => {
    const year = string_date.substring(0, 4);
    const month = string_date.substring(4, 6);
    const day = string_date.substring(6, 8);
    const hours = string_time.substring(0, 2);
    const minutes = string_time.substring(2, 4);

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  initStartOvertime=()=>{
    this.setState({
      SetOverStartTime: parseInt(this.props.data.ClockOutTimeMust) + 30,
    });
  }

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const { reason, row } = this.state;
    switch (tag) {
      case "OverTimeAndBunchOut":
        if (reason.length === 0) {
          message.error("請輸入加班原因");
          return;
        }
        if (this.state.lock) return;
        this.setState({ lock: true });
        row.Uid = _uuid();
        row.StaffCode = item.StaffCode;
        row.BunchDate = item.ClockDate;
        row.RecordIP = this.props.ip;
        row.RecordDescription = reason;
        row.SetOverStartTime = this.state.SetOverStartTime;
        this.api_add_item_bunchout_overtime(row).then((result) => {
          if (result === "success") {
            message.success("簽退並申請加班成功");
            if (this.props.onSuccess) this.props.onSuccess();
          } else {
            message.error("簽退失敗");
          }
        });
        break;
      case "BunchOut":
        if (this.state.lock) return;
        this.setState({ lock: true });
        row.Uid = _uuid();
        row.StaffCode = item.StaffCode;
        row.BunchDate = item.ClockDate;
        row.RecordIP = this.props.ip;
        console.log(row);
        this.api_add_item_bunchout(row).then((result) => {
          if (result === "success") {
            message.success("簽退成功");
            if (this.props.onSuccess) this.props.onSuccess();
          } else {
            message.error("簽退失敗");
          }
        });
        break;
      default:
    }
  };

  ////////
  render() {
    const { data } = this.props;
    //console.log(data);
    return (
      <Card title={"簽退日期：" + data.ClockDate}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* 不加班 */}
          <Alert
            description={
              <span>
                未符合加班規定(備註)，以計滿8小時為當日出勤內，超過之時間不列入出勤
                ，請按[直接簽退]
              </span>
            }
            type="info"
            closable
          />
          <button
            className="btn btn-primary btn-sm"
            style={{ width: "100%" }}
            disabled={this.state.lock}
            onClick={() => this.handle_btn_event("BunchOut", data)}
          >
            直接簽退，請按此
          </button>

          <div style={{ marginTop: "10px", marginBottom: "10px" }}>或</div>
          {/* 加班 */}
          <Alert
            description={
              <span>
                加班須經主管事先指派或同意，請當日出勤時間超過8小時
                。請按[簽退並申請加班時數]
              </span>
            }
            type="error"
            closable
          />
          <Input
            placeholder="請輸入加班理由"
            onChange={(e) => this.setState({ reason: e.target.value })}
          ></Input>
          {/* <Input
            placeholder="請輸入加班起算時間"
            value={this.state.SetOverStartTime}
            disabled={true}
            onChange={(e) =>
              this.setState({ SetOverStartTime: e.target.value })
            }
          ></Input> */}
          <button
            className="btn btn-danger btn-sm"
            style={{ width: "100%" }}
            onClick={() => this.handle_btn_event("OverTimeAndBunchOut", data)}
            disabled={this.state.lock}
          >
            簽退並申請加班時數，請按此
          </button>
          {/* 說明 */}
          <div style={{ marginTop: "10px", marginBottom: "10px" }}>
            <div style={{ color: "blue" }}>備註：</div>
            <p>
              1.請於彈性簽退時間60分鐘內簽退，未經主管事先指派或同意，不得申請加班。
            </p>
            <p>2.當日簽退後須有30分鐘休息時間，該段時間內不得申請加班。</p>
          </div>
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(OverTimeSelfModal);
